<template>
    <div class="w-100">
        <gf-custom-alert
            variant="info"
            :can-be-closed="true"
            element-class="my-3"
        >
        <template #body>
            <strong>Обратите внимание</strong>, что файлы, которые вы загружаете, должны соответствовать следующему формату:
            <ul>
                <li>Имя файла: <code>[имя]-[версия].tar.gz</code> или <code>[имя]_[версия].whl</code> где:
                <ul>
                    <li><strong>[имя]</strong> может содержать только латинские буквы, цифры, точки, дефисы и символы подчеркивания.</li>
                    <li><strong>[версия]</strong> должна начинаться с числа, за которым может следовать точка, числа, тире и латинские буквы.</li>
                </ul>
                </li>
            </ul>
            <p>Примеры корректных имен файлов:</p>
            <ul>
                <li><code>example-1.0.tar.gz</code></li>
                <li><code>module_1.2.3-alpha.whl</code></li>
            </ul>
            <p>Файлы, не соответствующие этому формату, не будут приняты.</p>
        </template>
      </gf-custom-alert>
        <gf-custom-multi-file-py-pi-uploader
            uploaderId="packageFile"
            uploaderName="files"
            allowedExtentions=".gz,.whl"
            v-model="files"
        ></gf-custom-multi-file-py-pi-uploader>

        <div class="d-flex justify-content-end">
            <button @click="postFiles" class="js-package-create-validation-target btn btn-sm btn-success mt-3" :disabled="getValidName || !isEmptyArray || getIsSent" type="submit">
                Загрузить
            </button>
        </div>
    </div>
</template>
<script>
import GfCustomMultiFilePyPiUploader from '@/shared-modules/shared-components/shared/GfCustomMultiFilePyPiUploader.vue';
import registryService from '@/shared-modules/modules/registry/registry.service.js';

export default {
    name: 'PyPiForm',
    components: {GfCustomMultiFilePyPiUploader},
    props: {
        alias: {
            type: String,
            default: null
        },
        nameProject: {
            type: String,
            default: null
        },
        category: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            files: [],
            groups: null,
        }
    },
    computed: {
        getIsSent() {
            return this.$store.getters.getIsSent 
        },
        getValidName() {
            return this.files.find((item) => !(/^(?<name>[a-zA-Z0-9_.-]+)[-_](?<version>\d+\.\d+(\.\d+)?([a-zA-Z0-9_.-]*)?)\.(tar\.gz|whl)$/.test(item?.name)) ) ? true : false 
        },
        isEmptyArray() {
            return this.files.length > 0 ? true : false 
        }
    },
    methods: {
        postFiles() {
            this.$store.dispatch('isSent', true)
            const MAX_SIZE = 2**20 * 50

            this.groups = this.files.reduce((acc, cur) => {
                const lastChunk = acc[acc.length - 1]

                if (!lastChunk || lastChunk.reduce((sum, item) => sum += item.size, 0) + cur.size > MAX_SIZE) {
                    acc.push([cur])
                } else lastChunk.push(cur)

                return acc
            }, []).map((group) => {
                const formData = new FormData()
                group.forEach(file => 
                    formData.append('files', file))
                    return formData;
            })

            if (this.groups) this.postGroups()
        },

        async postGroups() {
            switch (this.category) {
                case "project":
                    for (let index = 0; index < this.groups.length; index ++) {
                        await this.postProjectGroups(index)
                    }
                    
                    setTimeout(() => {window.location.href = `/project/${this.alias}/${this.nameProject}/package/`}, 1000)
                    break 
                case "company":
                    for (let index = 0; index < this.groups.length; index ++) {
                        await this.postCompanyGroups(index)
                    }

                    setTimeout(() => {window.location.href = `/company/${this.alias}/package/`}, 1000)
                    break 
                case "instance":
                    for (let index = 0; index < this.groups.length; index ++) {
                        await this.postInstanceGroups(index)
                    }

                    setTimeout(() => {window.location.href = `/admin/registry/instance/`}, 1000)
                    break 
                default:
                    alert("Что-то пошло не так")
            }  
        },

        async postProjectGroups(index) {
            try {
                const res = await registryService.postProjectGroups(
                    this.alias,
                    this.nameProject,
                    this.groups[index]
                )

                // console.log(res)
            } catch(e) {
                alert(e)
            }
        },
        async postCompanyGroups(index) {
            try {
                const res = await registryService.postCompanyGroups(
                    this.alias,
                    this.groups[index]
                )

                // console.log(res)
            } catch(e) {
                alert(e)
            }
        },
        async postInstanceGroups(index) {
            try {
                const res = await registryService.postInstanceGroups(
                    this.groups[index]
                )

                // console.log(res)
            } catch(e) {
                alert(e)
            }
        }
    }
}
</script>